import './Comment.scss';
import '../Survey/Survey.scss';
import { BaseOptions, CommentOptions, QuestionAttributeOptions } from '@reviews/interfaces';
import { Field, useFormikContext } from 'formik';
import { useEffect } from 'react';
import * as _ from 'lodash';

interface CommentProps {
    name: string;
    title: string | null;
    description: string | null;
    required: boolean;
    configuration: BaseOptions & CommentOptions;
    initialValue?: string;
}

export function Comment(props: CommentProps) {
    const { name, title, description, configuration, required, initialValue } = props;
    const answerField = `${name}-${QuestionAttributeOptions.ANSWER.toLowerCase()}`;
    const { setFieldValue, values } = useFormikContext<Record<string, any>>();

    useEffect(() => {
        if (initialValue && _.isEmpty(values[answerField])) {
            setFieldValue(answerField, initialValue, false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialValue]);

    return (
        <div className={'question'}>
            {configuration.options.group_heading && (
                <div className={'field-wrapper base-font-body category-name content-group-heading'}>
                    {configuration.options.group_heading}
                </div>
            )}
            <div className={'field-wrapper base-font-body category-name'}>
                {title}
                <div className={'caption category-description'}>{description}</div>
            </div>
            {configuration.options.title && (
                <div className="field-wrapper">
                    <div className={'mt-1'} />
                    <Field
                        className={'form-control text-area-border'}
                        name={`${name}-${QuestionAttributeOptions.TITLE.toLowerCase()}`}
                        id={`${name}-${QuestionAttributeOptions.TITLE.toLowerCase()}`}
                        type="text"
                        maxLength={configuration.options.title.options.max_length}
                        placeholder={configuration.options.title.options.placeholder}
                    />
                </div>
            )}
            <div className="field-wrapper" style={required ? { paddingBottom: '15px' } : {}}>
                <Field
                    as={'textarea'}
                    className={'form-control text-area-border'}
                    name={answerField}
                    id={answerField}
                    maxLength={configuration.options.max_length}
                    placeholder={configuration.options.placeholder}
                />
                {required && <label className={'required-label'}>Required</label>}
            </div>
        </div>
    );
}
